import React from 'react'

import { SH1, Stack, YStack } from '@zet/design-system'
import { Accordian } from '@zet/design-system/accordian'
import { i18n } from '@zet/localization'

const CreditScoreFaq = ({ bureau }) => {
  const faqData =
    bureau === 'CRIF'
      ? i18n.t('creditScoreFaq')
      : i18n.t('creditScoreExperianFaq')

  return (
    <YStack className="px-3">
      <SH1 className="py-3">{i18n.t('checkCreditScore.frequentQuestion')}</SH1>
      <Stack>
        {faqData?.map((item, index) => (
          <Accordian
            key={`lead-faq-${index}`}
            className="py-3"
            isIcon={false}
            title={item.question}
            content={item.answer}
            eventName="click_action"
            eventPayload={{
              item_name: 'homepage_new_credit_score_faqs',
              question: item.question,
            }}
          />
        ))}
      </Stack>
    </YStack>
  )
}

export default CreditScoreFaq
